module.exports = __webpack_public_path__ + "img/jorify_your_CG_products.c34f2e36.svg";